import {
  ContactType,
  ContractLegalForm,
  InvoicingFrequency,
} from "shared/types/rental-contracts";

/**
 * Response of POST /rental/contracts/extract-from-document.
 * Mirrors the backend ExtractedContractDto. Anything Ella was unsure about is
 * left null/empty and its field name listed in `lowConfidenceFields`.
 */
export type ExtractedProductKind = "rent" | "provision" | "property_tax" | "other";

export interface ExtractedContractProduct {
  kind: ExtractedProductKind;
  label: string;
  amount: number;
  templateId: number | null;
  odooProductVariantId: number | null;
  odooTemplateName: string | null;
  ledger: number | null;
  indexable: boolean;
  vatRate: number;
  buildingAttributeId: number | null;
}

export interface ExtractedContractContact {
  resourceId: number;
  contactId: number;
  contactType: ContactType;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone: string | null;
  name: string;
  wasExisting: boolean;
}

export interface ExtractedContractDto {
  fileLogId: number;
  products: ExtractedContractProduct[];
  signDate: string | null;
  startDate: string | null;
  endDate: string | null;
  legalForm: ContractLegalForm | null;
  invoicingFrequency: InvoicingFrequency | null;
  propertyTaxes: string | null;
  guaranteeAmount: number | null;
  numResidents: number | null;
  contacts: ExtractedContractContact[];
  lowConfidenceFields: string[];
  warnings: string[];
}

/** Dutch labels for the flagged field names, shown in the "check these" banner. */
export const LOW_CONFIDENCE_FIELD_LABELS: Record<string, string> = {
  baseRent: "Basishuur",
  provisions: "Provisie",
  propertyTaxAmount: "Onroerende voorheffing",
  signDate: "Ondertekeningsdatum",
  startDate: "Startdatum",
  endDate: "Einddatum",
  regime: "Regime / contracttype",
  legalForm: "Regime / contracttype",
  invoicingFrequency: "Facturatiefrequentie",
  propertyTaxRegime: "Onroerende voorheffing (regeling)",
  guaranteeAmount: "Huurwaarborg",
  numResidents: "Aantal bewoners",
  parties: "Contacten / partijen",
};
